<template>
  <a-layout id="box">
    <a-layout-content :style="{ marginTop: '0px', width: '100%' }" @click="showModal">
      <div class="content-node1">
        <div class="content-node1-1">
          <span class="content-node1-1-title">成为最受信任的数字化合作伙伴</span>
          <span class="content-node1-1-desc">精选服务案例展示，彰显了团队的专业实力，体现了以客户为中心的服务理念。 我们通过量身定制的解决方案，助力客户达成目标，取得成就。</span>
          <a-button type="primary" class="content-node1-1-btn">
            立即咨询
          </a-button>
        </div>
      </div>

      <div class="content-node5">
        <div class="content-node5-warp">
          <div class="content-node5-top">
            <p class="content-node5-top-title">定制化软件，就找无忧软件开发</p>
            <p class="content-node5-top-desc">为中小企业量身定制的数字化服务，助力突破发展瓶颈，增强企业核心竞争力。</p>
          </div>
          <div class="content-node5-body">
            <div class="content-node5-body-list">
              <div class="content-node5-body-item">
                <p class="content-node5-body-item-title">APP/小程序开发</p>
                <p class="content-node5-body-item-desc">提供电商、新零售和智能硬件等各行各位的一站式定制开发服务。</p>
                <p class="content-node5-body-item-btn"> 立即获取方案 ></p>
                <div class="content-node5-body-item-img">
                  <img src="../../assets/app.D5pwQ3HF.png" alt="">
                </div>
              </div>
              <div class="content-node5-body-item">
                <p class="content-node5-body-item-title">AI赋能</p>
                <p class="content-node5-body-item-desc">结合前沿的人工智能技术，提供语音识别、图像识别、人脸识别等定制化AI+解决方案。</p>
                <p class="content-node5-body-item-btn"> 立即获取方案 ></p>
                <div class="content-node5-body-item-img">
                  <img src="../../assets/a1.png" alt="">
                </div>
              </div>
              <div class="content-node5-body-item">
                <p class="content-node5-body-item-title">软件/系统开发</p>
                <p class="content-node5-body-item-desc">测算软件、能源软件、管理系统、监控系统、调度系统、检测系统、能耗系统等...</p>
                <p class="content-node5-body-item-btn"> 立即获取方案 ></p>
                <div class="content-node5-body-item-img">
                  <img src="../../assets/a2.png" alt="">
                </div>
              </div>
              <div class="content-node5-body-item">
                <p class="content-node5-body-item-title">物联网开发</p>
                <p class="content-node5-body-item-desc">深入理解物联网，研究系统开发与应用，实现软硬件无缝互联集成。</p>
                <p class="content-node5-body-item-btn"> 立即获取方案 ></p>
                <div class="content-node5-body-item-img">
                  <img src="../../assets/a3.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-node6">
        <div class="content-node6-body">

          <div class="content-node6-body-header">
            <p>全方位优势，助力您的数字化转型</p>
            <span>核心成员拥有深厚的互联网行业经验，具备多领域和跨行业的数字化转型能力。</span>
          </div>

          <div class="content-node6-body-middle">
            <div class="content-node6-body-item">
              <div class="content-node6-body-middle-top">
                <span class="content-node6-body-middle-top-title">10</span>
                <span class="content-node6-body-middle-top-remark">年</span>
              </div>
              <div class="content-node6-body-middle-line"></div>
              <div class="content-node6-body-middle-desc">
                <span>xxxx十年间深耕软件行业，经验丰富。</span>
              </div>
            </div>
            <div class="content-node6-body-item">
              <div class="content-node6-body-middle-top">
                <span class="content-node6-body-middle-top-title">0</span>
                <span class="content-node6-body-middle-top-remark">纠纷</span>
              </div>
              <div class="content-node6-body-middle-line"></div>
              <div class="content-node6-body-middle-desc">
                <span>所有方案均可通过严格的第三方检测标准，并与信创系统兼容。</span>
              </div>
            </div>
            <div class="content-node6-body-item">
              <div class="content-node6-body-middle-top">
                <span class="content-node6-body-middle-top-title">90</span>
                <span class="content-node6-body-middle-top-remark">%</span>
              </div>
              <div class="content-node6-body-middle-line"></div>
              <div class="content-node6-body-middle-desc">
                <span>客户满意度高达 90%，获得众多客户的一致好评。</span>
              </div>
            </div>
            <div class="content-node6-body-item">
              <div class="content-node6-body-middle-top">
                <span class="content-node6-body-middle-top-title">100+</span>
                <span class="content-node6-body-middle-top-remark">万</span>
              </div>
              <div class="content-node6-body-middle-line"></div>
              <div class="content-node6-body-middle-desc">
                <span>已服务客户产品累计用户突破100万，赢得用户广泛好评。</span>
              </div>
            </div>
          </div>
          <div class="content-node6-body-footer">
            <div class="content-node6-body-footer-item">
              <div class="content-node6-body-footer-item-logo">

              </div>
              <div class="content-node6-body-footer-item-desc">
                <p>经验丰富</p>
                <span>帮助知名企业改革创新，完成上百个数字化转型项目的落地与运营。</span>
              </div>
            </div>
            <div class="content-node6-body-footer-item">
              <div class="content-node6-body-footer-item-logo">

              </div>
              <div class="content-node6-body-footer-item-desc">
                <p>安全保障</p>
                <span>帮助知名企业改革创新，完成上百个数字化转型项目的落地与运营。</span>
              </div>
            </div>
            <div class="content-node6-body-footer-item">
              <div class="content-node6-body-footer-item-logo">

              </div>
              <div class="content-node6-body-footer-item-desc">
                <p>技术底座</p>
                <span>技术通过百个项目验证，自研监测组件与大模型服务融合提升业务价值。</span>
              </div>
            </div>
            <div class="content-node6-body-footer-item">
              <div class="content-node6-body-footer-item-logo">

              </div>
              <div class="content-node6-body-footer-item-desc">
                <p>服务优先</p>
                <span>用高水平行业知识与技能打造一流服务体验，建立长期可信赖的客户关系。</span>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="content-node7">
        <img src="../../assets/kf.png" alt="">
      </div>
      <div id="content-node2" class="content-node2">
        <div class="content-node2-1">
          <p>基于行业经验的精选案例</p>
          <span>全面、有效、专业，助力企业数字化转型与智能化升级</span>
        </div>
        <div class="content-node2-2">
          <div class="content-node2-2-body">
            <div class="content-node2-2-item">
              <div class="content-node2-2-item-logo">
                <img src="../../assets/2a2d0c35795850cfab8e.png" />
              </div>
              <div class="content-node2-2-item-desc">
                <span class="content-node2-2-item-desc-title">数字化公益项目-母亲邮包/春蕾计划</span>
                <span
                  class="content-node2-2-item-desc-remark">在全球范围内，贫困和教育不平等仍是亟待解决的社会问题。为了有效支持和改善贫困母亲和失学女童的生活状况，某发展基金会发起了两个重要的公益项目：针对贫困母亲的援助项目和春蕾计划。这两个项目旨在通过数字化手段，提高慈善捐赠的效率和透明度，确保捐赠能够精准到达需要帮助的人手中。</span>
              </div>
              <div class="content-node2-2-item-btn">
                <a-button type="primary" class="content-node2-2-item-btn-1">
                  公益项目
                </a-button>
                <a-button type="primary" class="content-node2-2-item-btn-2">
                  立即咨询
                </a-button>
              </div>
              <div class="content-node2-2-item-line"></div>
            </div>
            <div class="content-node2-2-item">
              <div class="content-node2-2-item-logo">
                <img src="../../assets/a2.jpg" />
              </div>
              <div class="content-node2-2-item-desc">
                <span class="content-node2-2-item-desc-title">Noknok-玩转数字名片</span>
                <span
                  class="content-node2-2-item-desc-remark">Noknok以其独特的产品理念，致力于将传统的纸质名片转变为数字化、智能化的名片，ificially提升了名片管理的便捷性和效率。</span>
              </div>
              <div class="content-node2-2-item-btn">
                <a-button type="primary" class="content-node2-2-item-btn-1">
                  社交app
                </a-button>
                <a-button type="primary" class="content-node2-2-item-btn-2">
                  立即咨询
                </a-button>
              </div>
              <div class="content-node2-2-item-line"></div>
            </div>
            <div class="content-node2-2-item">
              <div class="content-node2-2-item-logo">
                <img src="../../assets/n3.jpg" />
              </div>
              <div class="content-node2-2-item-desc">
                <span class="content-node2-2-item-desc-title">与伯俊大麦合作：智慧收银系统</span>
                <span class="content-node2-2-item-desc-remark">伯俊大麦携手无忧软件开发，为门店提供高效便捷的数字化运营解决方案。</span>
              </div>
              <div class="content-node2-2-item-btn">
                <a-button type="primary" class="content-node2-2-item-btn-1">
                  智慧收银
                </a-button>
                <a-button type="primary" class="content-node2-2-item-btn-2">
                  立即咨询
                </a-button>
              </div>
              <div class="content-node2-2-item-line"></div>
            </div>
            <div class="content-node2-2-item">
              <div class="content-node2-2-item-logo">
                <img src="../../assets/n4.png" />
              </div>
              <div class="content-node2-2-item-desc">
                <span class="content-node2-2-item-desc-title">与Fanbook合作：社交App智能社区</span>
                <span class="content-node2-2-item-desc-remark">Fanbook是创梦天地的一款游戏圈子导向的社交app，无忧软件开发有幸参与其中部分开发工作。</span>
              </div>
              <div class="content-node2-2-item-btn">
                <a-button type="primary" class="content-node2-2-item-btn-1">
                  社交app
                </a-button>
                <a-button type="primary" class="content-node2-2-item-btn-2">
                  立即咨询
                </a-button>
              </div>
              <div class="content-node2-2-item-line"></div>
            </div>
            <div class="content-node2-2-item">
              <div class="content-node2-2-item-logo">
                <img src="../../assets/n5.png" />
              </div>
              <div class="content-node2-2-item-desc">
                <span class="content-node2-2-item-desc-title">无人机充换电小程序</span>
                <span class="content-node2-2-item-desc-remark">面对农业现代化中无人机续航和充电不便的挑战，项目提出了一种高效、安全的电池充换电方案。</span>
              </div>
              <div class="content-node2-2-item-btn">
                <a-button type="primary" class="content-node2-2-item-btn-1">
                  物联网充电桩
                </a-button>
                <a-button type="primary" class="content-node2-2-item-btn-2">
                  立即咨询
                </a-button>
              </div>
              <div class="content-node2-2-item-line"></div>
            </div>
            <div class="content-node2-2-item">
              <div class="content-node2-2-item-logo">
                <img src="../../assets/n6.png" />
              </div>
              <div class="content-node2-2-item-desc">
                <span class="content-node2-2-item-desc-title">3D模具智慧生产报价系统</span>
                <span class="content-node2-2-item-desc-remark">我们为客户打造的【3D模具智慧生产报价系统】实现了全自动报价功能，极大地简化了传统的报价流程。</span>
              </div>
              <div class="content-node2-2-item-btn">
                <a-button type="primary" class="content-node2-2-item-btn-1">
                  智慧管网
                </a-button>
                <a-button type="primary" class="content-node2-2-item-btn-2">
                  立即咨询
                </a-button>
              </div>
              <div class="content-node2-2-item-line"></div>
            </div>
          </div>
        </div>
        <div class="content-node2-3">
          <p><span class="content-node2-3-desc">查看更多</span> <a-icon class="content-node2-3-icon" type="down" /></p>
        </div>
      </div>
      <div class="content-node3">
        <div class="content-node3-title">品牌的一致认可</div>
        <div class="content-node3-mask"></div>
        <div class="content-node3-data">
          <div class="content-node3-data-item">
            <ul>
              <li><img src="../../assets/1.png"></li>
              <li><img src="../../assets/2.png"></li>
              <li><img src="../../assets/3.png"></li>
              <li><img src="../../assets/5.png"></li>
              <li><img src="../../assets/6.png"></li>
              <li><img src="../../assets/7.png"></li>
              <li><img src="../../assets/8.png"></li>
              <li><img src="../../assets/9.png"></li>
              <li><img src="../../assets/10.png"></li>
              <li><img src="../../assets/12.png"></li>
              <li><img src="../../assets/13.png"></li>
              <li><img src="../../assets/14.png"></li>
              <li><img src="../../assets/1.png"></li>
              <li><img src="../../assets/2.png"></li>
              <li><img src="../../assets/3.png"></li>
              <li><img src="../../assets/5.png"></li>
              <li><img src="../../assets/6.png"></li>
              <li><img src="../../assets/7.png"></li>
              <li><img src="../../assets/8.png"></li>
              <li><img src="../../assets/9.png"></li>
              <li><img src="../../assets/10.png"></li>
              <li><img src="../../assets/12.png"></li>
              <li><img src="../../assets/13.png"></li>
              <li><img src="../../assets/14.png"></li>
            </ul>
          </div>
          <div class="content-node3-data-item">
            <ul>
              <li><img src="../../assets/1.png"></li>
              <li><img src="../../assets/2.png"></li>
              <li><img src="../../assets/3.png"></li>
              <li><img src="../../assets/5.png"></li>
              <li><img src="../../assets/6.png"></li>
              <li><img src="../../assets/7.png"></li>
              <li><img src="../../assets/8.png"></li>
              <li><img src="../../assets/9.png"></li>
              <li><img src="../../assets/10.png"></li>
              <li><img src="../../assets/12.png"></li>
              <li><img src="../../assets/13.png"></li>
              <li><img src="../../assets/14.png"></li>
              <li><img src="../../assets/1.png"></li>
              <li><img src="../../assets/2.png"></li>
              <li><img src="../../assets/3.png"></li>
              <li><img src="../../assets/5.png"></li>
              <li><img src="../../assets/6.png"></li>
              <li><img src="../../assets/7.png"></li>
              <li><img src="../../assets/8.png"></li>
              <li><img src="../../assets/9.png"></li>
              <li><img src="../../assets/10.png"></li>
              <li><img src="../../assets/12.png"></li>
              <li><img src="../../assets/13.png"></li>
              <li><img src="../../assets/14.png"></li>
            </ul>
          </div>
          <div class="content-node3-data-item">
            <ul>
              <li><img src="../../assets/1.png"></li>
              <li><img src="../../assets/2.png"></li>
              <li><img src="../../assets/3.png"></li>
              <li><img src="../../assets/5.png"></li>
              <li><img src="../../assets/6.png"></li>
              <li><img src="../../assets/7.png"></li>
              <li><img src="../../assets/8.png"></li>
              <li><img src="../../assets/9.png"></li>
              <li><img src="../../assets/10.png"></li>
              <li><img src="../../assets/12.png"></li>
              <li><img src="../../assets/13.png"></li>
              <li><img src="../../assets/14.png"></li>
              <li><img src="../../assets/1.png"></li>
              <li><img src="../../assets/2.png"></li>
              <li><img src="../../assets/3.png"></li>
              <li><img src="../../assets/5.png"></li>
              <li><img src="../../assets/6.png"></li>
              <li><img src="../../assets/7.png"></li>
              <li><img src="../../assets/8.png"></li>
              <li><img src="../../assets/9.png"></li>
              <li><img src="../../assets/10.png"></li>
              <li><img src="../../assets/12.png"></li>
              <li><img src="../../assets/13.png"></li>
              <li><img src="../../assets/14.png"></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="content-node4">
        <a-modal v-model="visible" title="扫码联系" ok-text="确定" cancelText="关闭" @ok="hideModal"
          style="text-align: center;">
          <img src="../../assets/qr02.jpg" />
        </a-modal>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      visible: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.headerScroll)
    // 添加全局点击事件监听
    document.addEventListener('click', this.closeMenu);
  },
  // 组件销毁前
  beforeDestroy() {
    window.removeEventListener('scroll', this.headerScroll)
    // 移除事件监听
    document.removeEventListener('click', this.closeMenu);
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    hideModal() {
      this.visible = false;
    },
    //监听页面滚动事件
    headerScroll(data) {
      // 页面滑动的距离
      let scrollTop = document.documentElement.scrollTop
      console.log(scrollTop)
      if (scrollTop <= 10) {
        this.headerStyle = {
          position: 'fixed',
          zIndex: 1,
          width: '100%'
        }
      } else {
        this.headerStyle = {
          position: 'fixed',
          zIndex: 1,
          width: '100%',
          background: "#ffff",
          borderBottom: "1px solid rgb(239 239 239)"
        }
      }
    },
    toPage(url) {
      // this.$message.success('你好，Ant Design Vue!');
      this.$router.push({
        path: url
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .content-node7 {
    img {
      width: 75px !important;
      height: auto !important;
    }
  }

  .ant-layout-header {
    padding: 0px 0px !important;
  }

  .content-node7 {
    bottom: 30% !important;
  }

  .content-node3 {
    background-color: #f8fbff !important;
  }

  .content-node6-body-header>span {
    font-size: 14px !important;
  }

  .content-node3,
  .content-node6 {
    padding: 50px 0px !important;
  }

  .content-node2-1,
  .content-node5-top {
    padding-top: 50px !important;
  }

  .content-node5-body-list {
    padding: 0px 0px !important;
  }

  .content-node5-top-desc,
  .content-node1-1-desc {
    width: auto !important;
    font-size: 14px !important;
  }

  .content-node1-1 {
    height: 432px !important;
  }

  .content-node6-body-middle-top-title,
  .footer-node-1-title,
  .content-node3-title,
  .content-node5-top-title,
  .content-node1-1-title {
    font-size: 30px !important;
  }

  .content-node6-body-header>p {
    font-size: 30px !important;
  }

  .content-node2-1 {
    p {
      font-size: 30px !important;
    }

    span {
      font-size: 14px !important;
    }
  }

  .footer-node-1-title {
    font-size: 25px !important;
  }


}


.ant-layout-header {
  cursor: pointer;
  background: #eff6fc;
}

.content-node7 {
  position: fixed;
  right: 0px;
  bottom: 50%;
  z-index: 2;

  img {
    width: 136px;
    height: 224px;
  }
}


.content-node6 {
  cursor: pointer;
  background: #f8fbff url("../../assets/b1.png") no-repeat top/60%;
  padding: 100px 0px;

  .content-node6-body {
    width: 75%;
    margin: 0 auto;

    .content-node6-body-footer-item-logo:hover {
      transform: scale(0.5);
    }

    .content-node6-body-footer>.content-node6-body-footer-item:nth-child(1) {
      .content-node6-body-footer-item-logo {
        background-image: url("../../assets/y1.png");
        width: 56px;
        height: 56px;
        background-position: 100% 100%;
        background-repeat: no-repeat;
        background-size: cover;
        margin: 0 auto;
        transition: all 1s;
      }
    }

    .content-node6-body-footer>.content-node6-body-footer-item:nth-child(2) {
      .content-node6-body-footer-item-logo {
        background-image: url("../../assets/y2.png");
        width: 56px;
        height: 56px;
        background-position: 100% 100%;
        background-repeat: no-repeat;
        background-size: cover;
        margin: 0 auto;
        transition: all 1s;
      }
    }

    .content-node6-body-footer>.content-node6-body-footer-item:nth-child(3) {
      .content-node6-body-footer-item-logo {
        background-image: url("../../assets/y3.png");
        width: 56px;
        height: 56px;
        background-position: 100% 100%;
        background-repeat: no-repeat;
        background-size: cover;
        margin: 0 auto;
        transition: all 1s;
      }
    }

    .content-node6-body-footer>.content-node6-body-footer-item:nth-child(4) {
      .content-node6-body-footer-item-logo {
        background-image: url("../../assets/y4.png");
        width: 56px;
        height: 56px;
        background-position: 100% 100%;
        background-repeat: no-repeat;
        background-size: cover;
        margin: 0 auto;
        transition: all 1s;
      }
    }

    .content-node6-body-footer {
      display: flex;
      justify-content: space-between;
      background-color: #ffff;
      justify-content: center;
      flex-wrap: wrap;



      .content-node6-body-footer-item {
        width: 280px;
        height: 228px;
        padding: 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .content-node6-body-footer-item-desc {
          p {
            font-size: 18px;
            margin-bottom: 8px;
            text-align: center;
          }

          span {
            font-size: 14px;
            display: block;
            margin: 14px 0px;
            text-align: center;
          }
        }
      }
    }

    .content-node6-body-middle>.content-node6-body-item:nth-child(4)::after {
      content: "";
      background-color: #2570f9;
      width: 0px !important;
      height: 60px;
      position: absolute;
      right: -61px;
      top: 36%;
    }

    .content-node6-body-middle {
      display: flex;
      justify-content: space-around;
      margin-bottom: 50px;
      flex-wrap: wrap;

      .content-node6-body-item::after {
        content: "";
        background-color: #2570f9;
        width: 2px;
        height: 60px;
        position: absolute;
        right: -61px;
        top: 36%;
      }

      .content-node6-body-item {
        position: relative;
        width: 209px;
        margin-bottom: 30px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;

        .content-node6-body-middle-desc {
          font-size: 16px;
          text-align: start;
        }

        .content-node6-body-middle-line {
          width: 58px;
          height: 2px;
          background-color: #2570f9;
          margin: 10px 0px;
        }

        .content-node6-body-middle-top {
          .content-node6-body-middle-top-title {
            font-size: 96px;
            color: #2570f9;
          }

          .content-node6-body-middle-top-remark {
            font-size: 28px;
            color: #2570f9;
          }
        }
      }
    }

    .content-node6-body-header {
      p {
        font-size: 44px;
        font-weight: 500;
        margin-bottom: 16px;
      }

      span {
        font-size: 18px;
        margin-bottom: 50px;
        display: block;
      }
    }

  }
}


.footer-node {
  background: url("../../assets/bg.Du78Z1_B.png") no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  height: 338px;
  overflow: hidden;
  cursor: pointer;

  .footer-node-2 {
    display: flex;
    justify-content: space-around;

    .footer-node-2-qrCode {
      display: flex;
      justify-content: flex-start;

      .footer-node-2-qrCode-item {
        margin-right: 15px;

        .footer-node-2-qrCode-item-desc {
          color: #ffff;
          font-size: 10px;
        }

        .footer-node-2-qrCode-item-img {
          margin-bottom: 10px;

          img {
            width: 73px;
          }
        }
      }
    }
  }

  .footer-node-1 {
    margin-top: 50px;
    margin-bottom: 16px;

    .footer-node-1-btn {
      width: 150px;
      height: 40px;
    }

    .footer-node-1-title {
      font-size: 32px;
      color: #ffff;
      font-weight: 500;
      text-align: center;
    }
  }
}

.content-node5 {
  background-color: #ffff;
  cursor: pointer;

  .content-node5-warp {
    width: 75%;
    margin: 0 auto;

    .content-node5-body {
      .content-node5-body-list {
        display: flex;
        justify-content: space-between;
        padding-bottom: 100px;
        flex-wrap: wrap;

        .content-node5-body-item:hover>.content-node5-body-item-btn {
          color: #ffff;
        }

        .content-node5-body-item:hover {
          //animation: test 1s ease-in-out reverse;
          animation-timing-function: linear;
          box-shadow: 0 2px 20px #2970ff2b;
          background: #397dfa;
          color: #ffff;
          transform: translateY(-20px);
        }

        // @keyframes test {
        //   from {
        //     transform: translateY(0);
        //   }

        //   to {
        //     transform: translateY(-8px);
        //   }
        // }

        .content-node5-body-item {
          background: linear-gradient(104deg, rgb(239, 246, 252), rgb(255, 255, 255) 52.66%, rgb(228, 243, 255) 100.31%);
          border-radius: 6px;
          padding: 36px 30px 25px;
          width: 320px;
          height: 290px;
          margin-bottom: 60px;
          transition: all 1s;

          .content-node5-body-item-title {
            text-align: start;
            font-size: 26px;
            font-weight: 500;
            margin-bottom: 10px;
          }

          .content-node5-body-item-desc {
            text-align: start;
            font-size: 14px;
            letter-spacing: 1px;
            margin: 14px 0px;
          }

          .content-node5-body-item-btn {
            text-align: start;
            font-size: 14px;
            letter-spacing: 1px;
            color: #2570f9;
          }

          .content-node5-body-item-img {
            text-align: right;

            img {
              width: 166px;
            }
          }
        }
      }
    }

    .content-node5-top {
      padding-top: 100px;
      text-align: center;

      .content-node5-top-title {
        font-size: 44px;
        font-weight: 500;
        margin-bottom: 16px;
      }

      .content-node5-top-desc {
        font-size: 18px;
        margin-bottom: 40px;
      }
    }
  }
}

.content-node4 {}

.content-node3 {
  padding: 100px 0px;
  background-color: #ffff;
  cursor: pointer;

  .content-node3-title {
    text-align: center;
    font-size: 44px;
    font-weight: 600;
    margin-bottom: 40px;
  }

  .content-node3-mask {
    background-color: #2570f9;
  }

  .content-node3-data {
    width: 100%;
    overflow: hidden;

    .content-node3-data-item {
      width: 10000px;
      margin-bottom: 30px;

      @keyframes rolling {
        from {
          transform: translateX(-30%);
        }

        to {
          transform: translateX(-50%);
        }
      }

      ul {
        animation: rolling 180s linear infinite;

        li {
          width: 153px;
          margin-right: 16px;
          overflow: hidden;
          list-style: none;
          list-style-type: none;
          display: inline-block;

          img {
            width: 100%;
          }
        }
      }
    }
  }
}


.content-node2 {
  padding-top: 25px;
  background: #ffff;
  cursor: pointer;

  .content-node2-3 {
    overflow: hidden;

    .content-node2-3-desc {
      font-size: 14px;
      cursor: pointer;
    }

    .content-node2-3-icon {
      font-size: 10px;
    }
  }

  .content-node2-2 {
    width: 75%;
    margin: 0px auto;
    overflow: hidden;

    .content-node2-2-body {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    //hover 父对子 设置属性
    .content-node2-2-item:hover .content-node2-2-item-logo>img {
      transform: scale(1.5);
    }

    //hover 父对子 设置属性
    .content-node2-2-item:hover .content-node2-2-item-desc {
      color: #2570f9;
    }

    .content-node2-2-item:hover .content-node2-2-item-line::before {
      transform: scaleX(1);
    }

    .content-node2-2-item:not(:hover) .content-node2-2-item-line::before {
      transform-origin: left;
      transform: scaleX(0);
      transition: transform 0.3s ease;
    }

    .content-node2-2-item {
      width: 440px;
      height: 472px;
      overflow: hidden;
      margin-bottom: 60px;

      .content-node2-2-item-line {
        background-color: #f2f3f5;
        width: 100%;
        height: 2px;
        background-color: #f2f3f5;
        width: 100%;
        height: 2px;
        position: relative;
      }

      .content-node2-2-item-line::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #2570f9;
        transform: scaleX(0);
        transform-origin: left;
        transition: transform 0.3s ease;
      }

      .content-node2-2-item-btn {
        text-align: start;
        margin-bottom: 50px;

        .content-node2-2-item-btn-1 {
          display: inline-block;
          color: #2570f9;
          background-color: #eef4ff;
          border: none;
          height: 31px;
          width: 100px;
          margin-right: 10px;
        }

        .content-node2-2-item-btn-2 {
          display: inline-block;
          color: #2570f9;
          background-color: #eef4ff;
          border: none;
          height: 31px;
          width: 100px;
        }


      }

      .content-node2-2-item-logo {
        img {
          width: 100%;
          transform: scale(1.2);
          transition: all 0.6s;
        }

        overflow: hidden;
        border-radius: 10px;
        //盒子阴影
        box-shadow: 0px 1px 12px rgba(0, 0, 0, .06);
        margin-bottom: 30px;
        height: 247px;
      }

      .content-node2-2-item-desc {
        .content-node2-2-item-desc-title {
          display: block;
          font-size: 20px;
          text-align: start;
          margin-bottom: 12px;
        }

        .content-node2-2-item-desc-remark {
          display: block;
          font-size: 14px;
          text-overflow: ellipsis;
          text-align: start;
          display: -webkit-box;
          overflow: hidden;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          margin-bottom: 12px;
        }
      }
    }
  }

  .content-node2-1 {
    padding-top: 100px;

    p {
      font-size: 44px;
      font-weight: 500;
      margin-bottom: 16px;
      text-align: center;
    }

    span {
      font-size: 18px;
      display: block;
      margin-bottom: 50px;
      text-align: center;
    }
  }
}

.content-node1 {
  background: url("../../assets/banner-bg.f_05cGgG.png") center center / 1920px no-repeat rgb(239, 246, 252);
  cursor: pointer;

  .content-node1-1 {
    height: 650px;
    width: 75%;
    margin: 0px auto;
    text-align: start;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .content-node1-1-title {
      display: block;
      font-weight: 500;
      font-size: 56px;
      margin-bottom: 12px;
    }

    .content-node1-1-desc {
      display: block;
      font-size: 18px;
      width: 560px;
      margin-bottom: 24px;
    }

    .content-node1-1-btn {
      width: 96px;
    }
  }
}

.header-content {

  margin: 0px auto;
  display: flex;
  flex-direction: row;
  cursor: pointer;

  .header-logo {
    flex-grow: 0.5;

    overflow: hidden;

    img {
      width: 100px;
    }
  }

  .header-btn {
    display: flex;
    align-items: center;

    span {
      background-color: #2570f9;
      display: flex;
      align-items: center;
      height: 32px;
      color: #fff;
      padding: 18px 10px;
      border-radius: 50px;
    }

  }

  .header-menu {
    height: 64px;
    display: flex;
    flex-grow: 1;

    .hader-menu-item:nth-child(2) {
      .hader-menu-item-title::after {
        background: transparent;
        bottom: 16px;
        content: " ";
        height: 2px;
        // left: 27%;
        position: absolute;
        transform: translate(-100%);
        transition: all 1s ease-in-out;
        width: 100px;
      }
    }

    .hader-menu-item {
      padding: 0px 20px;
      line-height: 64px;
      height: 64px;
      position: relative;

      /* 进入和离开的动画 */
      .fade-enter-active,
      .fade-leave-active {
        transition: all 1s;
      }

      /* 进入开始和离开结束的状态 */
      .fade-enter,
      .fade-leave-to {
        opacity: 0;
        transform: translateY(-10px);
      }

      .hader-sub-menus {
        position: absolute;
        background: #fff;
        display: flex;
        align-content: center;
        justify-content: start;
        overflow: hidden;
        left: -99px;


        .right {
          width: 800px;

          h1 {
            font-size: 18px;
            line-height: 100%;
            margin-top: 50px;
            font-weight: bold;
            text-align: start;
            padding-left: 10px;
          }

          .sub-model {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            padding: 10px 0px;

            div:hover {
              transform: translateY(-10px);
            }

            div {
              width: 245px;
              transition: all 1s;
              background: linear-gradient(180deg, #fcfcfd 0%, #f6fbfe 100%);
              margin: 10px;

              h1 {
                font-size: 15px;
                font-weight: 400;
                margin: 0px;
                padding: 10px;
              }

              p {
                font-size: 8px;
                line-height: 15px;
                text-align: start;
                padding: 0px 10px;
                padding-right: 54px;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                display: -webkit-box;
              }
            }
          }
        }

        .left {
          background-image: url("../../assets/sub-bg.png");
          background-repeat: no-repeat;
          background-size: cover;

          h1 {
            font-size: 18px;
            line-height: 100%;
            margin-top: 50px;
            font-weight: bold;
          }

          .btn {
            margin-top: 80px;
            text-align: center;
            color: #2570f9;
          }

          p {
            margin-top: 30px;
            padding: 0px 60px;
            font-size: 12px;
            width: 300px;
            line-height: 20px;
            text-align: start;
          }
        }
      }

      .hader-menu-item-title {
        height: 100%;
        font-size: 18px;
        color: #4e5969;
        text-align: center;
        width: 100%;

        i {
          margin: 0px 5px;
        }
      }

      .hader-menu-item-title::after {
        background: transparent;
        bottom: 16px;
        content: " ";
        height: 2px;
        // left: 27%;
        position: absolute;
        transform: translate(-100%);
        width: 72px;
        transition: all 1s ease-in-out;
      }

      .hader-menu-item-title:hover::after {
        color: #2570f9;
        transition: all .1s ease-in-out;
        background-color: #2570f9;
      }

      .hader-menu-item-title:hover {
        color: #2570f9;
        cursor: pointer;
        font-weight: bold;
      }



    }
  }
}
</style>